module.exports = __webpack_public_path__ + "media/images/photo-new-designs-bbf80f8c8957f9ce7087903106bea4d1.png";